<template>
  <login-layout :title="$t('Recupero Password')">
    <x-form
      ref="formRef"
      submit-block
      @submit="submit"
    >
      <form-group :name="$t('Nome utente o Email')" no-label>
        <x-input
          id="resetUsername"
          type="text"
          name="username"
          :placeholder="$t('Nome utente o Email')"
          required
          autocomplete="username"
        />
      </form-group>
    </x-form>

    <template #forgot-credentials>
      <i18n-t keypath="Torna alla schermata di {0}">
        <router-link :to="{ name: 'login' }">
          {{ $t('Log In') }}
        </router-link>
      </i18n-t>
    </template>
  </login-layout>
</template>

<script lang="ts" setup>
import { http } from '../../http';
import LoginLayout from '../../components/login-layout.vue';
import { useRoute, useRouter } from 'vue-router';
import { useTemplateRef } from 'vue';
import type { ComponentExposed } from 'vue-component-type-helpers';
import type XForm from '../../components/x-form.vue'

defineOptions({
  name: 'ResetpasswordPage',
});

const form = useTemplateRef<ComponentExposed<typeof XForm>>('formRef');
const router = useRouter();
const route = useRoute();

async function submit() {
  if (!(form.value?.form instanceof HTMLFormElement)) {
    return;
  }

  const data = new FormData(form.value.form);
  data.append('check', (await http.post('/api/auth/token')).data.token);
  const result = (await http.post('/api/auth/reset', data)).data.result;
  if (result == 'ok') {
    router.push({
      name: 'login',
      query: route.query,
    });
  }
}
</script>
